import * as AppConstants from "../utils/constants/AppConstants";
import * as axios from "axios";

export const JournalApi = {
    getJournal(sid, page, objectId, step) {
        return (
            axios
                .get(AppConstants.JOURNAL_URL_PATH + `?sid=${sid}&step=${step}&page=${page}&id=${objectId}`)
                .then(response => {
                        return response.data
                    }
                )

        )
    },
    getFilteredJournal(sid, objectId, start, finish, search, page, step) {
        return (
            axios
                .get(AppConstants.JOURNAL_URL_PATH + `?sid=${sid}&id=${objectId}&start=${start}&finish=${finish}&search=${search}&page=${page}&step=${step}`)
                .then(response => {
                        return response.data
                    }
                )

        )
    }
}